export const FETCH_CITY_AREAS = 'app/core/reducers/areas/FETCH_CITY_AREAS';
export const FETCH_AREA_BY_ID = 'app/core/reducers/areas/FETCH_AREA_BY_ID';
